import { Client } from './Client';

export type UpdateClient = Omit<Client, 'id'> & {
    clientId: string;
};

export const defaultUpdateClient: UpdateClient = {
    clientId: '',
    name: '',
    nip: '',
    email: '',
    phoneNumber: '',
    street: '',
    houseNumber: '',
    apartamentNumber: '',
    city: '',
    zipCode: '',
    country: '',
    notes: '',
};
